import React, { useState } from "react";
import Feature from "./Feature";
import Footer from "./Footer";
import { Box, Typography } from "@mui/material";
import AboutUs from "./AboutUs";
import CommonButton from "../../common/components/CommonButton";
import theme from "../../theme";
import Modules from "./Module";

const Services = () => {
  const [isServices, setIsServices] = useState(true);

  return (
    <Box sx={{ overflowX: 'hidden' }}>
      <Box
        sx={{
          height: '55vh',
          width: '95%',
          borderRadius: 2,
          marginLeft: 4,
          marginTop: 2,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Background Image Container */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1,
            backgroundImage: `url(/Images/servicebackground.png)`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        />

        {/* Content Container */}
        <Box
          sx={{
            position: 'relative',
            zIndex: 3,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            mt: 1,
            alignItems: 'center',
            my: '50px',
          }}
        >
          {/* Buttons */}
          <Box
            sx={{
              display: 'flex',
              mb: 1,
              mt: 2,
              padding: '5px',
              borderRadius: 1,
              justifyContent: 'center',
              background: 'white'
            }}
          >
            <CommonButton
              label="My DCP Services"
              background={isServices ? theme.palette.primary.main : "Transparent"}
              fontWeight={isServices ? 600 : 400}
              width="200px"
              height="45px"
              fontSize="17px"
              marginBottom="0px"
              color={!isServices ? theme.palette.background.dark : theme.palette.secondary.main}
              handleClick={() => setIsServices(true)}
            />
            <CommonButton
              label="My DCP Resources"
              background={isServices ? "Transparent" : theme.palette.primary.main}
              fontWeight={isServices ? 400 : 600}
              width="200px"
              height="45px"
              marginBottom="0px"
              color={isServices ? theme.palette.background.dark : theme.palette.secondary.main}
              fontSize="17px"
              handleClick={() => setIsServices(false)}
            />
          </Box>
          <Typography
            sx={{
              color: 'white',
              fontSize: '60px',
              width: '65%',
              textAlign: 'center',
              fontWeight: 600,
              lineHeight: 'normal',
              marginTop: '30px'
            }}
          >
            {isServices ? 'Smart Tools and Expert Support for Student College Journey' : 'Expert Guidance for Every Step of Your College Journey'}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'white',
              fontSize: '17px',
              width: '60%',
              textAlign: 'center',
              fontWeight: 600,
              mt: 1
            }}
          >
            {isServices ? 'My DCP Services brings together personalized planning, data-driven insights, and expert guidance — helping students stay organized, make confident decisions, and build strong college applications from start to finish.' : 'Connect with experienced counselors, tutors, coaches, and mentors who provide personalized support — from planning and test prep to academics and impactful projects.'}
          </Typography>
        </Box>
      </Box>
      <Modules isService={isServices} />
      <Feature isServices={isServices} />
      <AboutUs isServices={isServices} />
      <Footer />
    </Box>
  );
};

export default Services;